const EcaBadge = () => (
  <span className="inline-flex items-stretch shadow-[4px_4px_0_rgba(0,0,0,0.25)]">
    <span className="flex items-center bg-[#ffd200] px-3 py-2 text-[11px] font-black uppercase tracking-[0.16em] text-[#1c2a5e] md:text-xs">
      Member
    </span>
    <span className="flex items-center gap-2.5 bg-[#1c2a5e] px-4 py-2">
      <span className="flex items-end gap-[3px]" aria-hidden="true">
        <i className="block h-2.5 w-[3px] bg-white" />
        <i className="block h-3.5 w-[3px] bg-white" />
        <i className="block h-[18px] w-[3px] bg-white" />
      </span>
      <span className="font-display text-sm font-black uppercase tracking-[0.12em] text-white md:text-base">
        ECA WA
      </span>
      <span className="hidden text-[9px] uppercase tracking-[0.14em] text-white/60 md:block">
        Committed to electrical excellence
      </span>
    </span>
  </span>
);

export default EcaBadge;
